var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStep2ChoosePlanActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#E3F444"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_337_442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.16 39.09C44.6722 39.09 48.33 35.4322 48.33 30.92C48.33 26.4078 44.6722 22.75 40.16 22.75C35.6478 22.75 31.99 26.4078 31.99 30.92C31.99 35.4322 35.6478 39.09 40.16 39.09Z",
    stroke: "#2C2C2C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1699 57.59C27.4999 56.02 27.1299 54.3 27.1299 52.49C27.1299 45.29 32.9599 39.46 40.1599 39.46C47.3599 39.46 53.1899 45.29 53.1899 52.49C53.1899 54.24 52.8399 55.91 52.2199 57.44",
    stroke: "#2C2C2C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.96 42.64C27.3897 42.64 30.17 39.8597 30.17 36.43C30.17 33.0003 27.3897 30.22 23.96 30.22C20.5303 30.22 17.75 33.0003 17.75 36.43C17.75 39.8597 20.5303 42.64 23.96 42.64Z",
    stroke: "#2C2C2C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.05 49.0199V45.0899C19.05 43.7699 20.13 42.6899 21.45 42.6899H27.17C27.83 42.6899 28.43 42.9599 28.87 43.3899",
    stroke: "#2C2C2C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7501 36.43C62.7501 39.86 59.9701 42.64 56.5401 42.64C53.1101 42.64 50.3301 39.86 50.3301 36.43C50.3301 33 53.1101 30.22 56.5401 30.22C59.9701 30.22 62.7501 33 62.7501 36.43Z",
    stroke: "#2C2C2C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6299 43.3899C52.0599 42.9599 52.6699 42.6899 53.3299 42.6899H59.0499C60.3699 42.6899 61.4499 43.7699 61.4499 45.0899V49.0199",
    stroke: "#2C2C2C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_337_442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.5,
    height: 36.34,
    fill: "white",
    transform: "translate(17 22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStep2ChoosePlanActive);
export default __webpack_public_path__ + "static/media/icon_step2_choose_plan_active.736418560cb246ced85e9956d4bab09e.svg";
export { ForwardRef as ReactComponent };